import { type CanvasElementFrom, type EmptyDef } from '@blaze-runtime/engine-domain';

import { type CanvasElementDefinition } from '../../canvas-elements/element-definition';
import { registerElementDefinition } from '../../services/element-definitions.service';

import { BreakLineComponent } from './break-line.component';

// Extend the CanvasElementDefinitions type
declare module '@blaze-runtime/engine-domain' {
  interface CanvasElementDefinitions {
    breakLine: BreakLineDef;
  }
}

export type BreakLineDef = EmptyDef;
export type BreakLineElement = CanvasElementFrom<'breakLine'>;

export function getBreakLineDefinition(): CanvasElementDefinition<'breakLine'> {
  return {
    type: 'breakLine',
    componentType: BreakLineComponent,
    isListed: false,
    name: 'Break Line',
    width: {
      mode: 'full',
    },
    version: 1,
  };
}

registerElementDefinition(getBreakLineDefinition());
